var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{staticClass:"btn",style:({
    height: _vm.height,
    background: _vm.bgcolor,
    color: _vm.btncolor,
    width: _vm.btnwidth,
    border: _vm.btnborder,
    margin: _vm.btnmargin,
    'line-height': _vm.height,
    'font-size': _vm.fontsize,
    'font-weight': _vm.fontweight,
    'border-radius': _vm.borderradius,
    'box-shadow': _vm.btnShadow, //'1px 5px 8px 0 rgba(249, 89, 27, 0.5)',
  }),on:{"click":_vm.btnClick}},[_vm._v("\n  "+_vm._s(_vm.btntext)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }